var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 57,
    viewBox: "0 0 66 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 57,
    rx: 12,
    fill: "#FEC10D",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 17H22.3333C21.597 17 21 17.597 21 18.3333V27.6667C21 28.403 21.597 29 22.3333 29H29C29.7364 29 30.3333 28.403 30.3333 27.6667V18.3333C30.3333 17.597 29.7364 17 29 17Z",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 17H22.3333C21.597 17 21 17.597 21 18.3333V27.6667C21 28.403 21.597 29 22.3333 29H29C29.7364 29 30.3333 28.403 30.3333 27.6667V18.3333C30.3333 17.597 29.7364 17 29 17Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.667 17H37.0003C36.2639 17 35.667 17.597 35.667 18.3333V22.3333C35.667 23.0697 36.2639 23.6667 37.0003 23.6667H43.667C44.4034 23.6667 45.0003 23.0697 45.0003 22.3333V18.3333C45.0003 17.597 44.4034 17 43.667 17Z",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.667 17H37.0003C36.2639 17 35.667 17.597 35.667 18.3333V22.3333C35.667 23.0697 36.2639 23.6667 37.0003 23.6667H43.667C44.4034 23.6667 45.0003 23.0697 45.0003 22.3333V18.3333C45.0003 17.597 44.4034 17 43.667 17Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.667 29H37.0003C36.2639 29 35.667 29.597 35.667 30.3333V39.6667C35.667 40.403 36.2639 41 37.0003 41H43.667C44.4034 41 45.0003 40.403 45.0003 39.6667V30.3333C45.0003 29.597 44.4034 29 43.667 29Z",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.667 29H37.0003C36.2639 29 35.667 29.597 35.667 30.3333V39.6667C35.667 40.403 36.2639 41 37.0003 41H43.667C44.4034 41 45.0003 40.403 45.0003 39.6667V30.3333C45.0003 29.597 44.4034 29 43.667 29Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34.3281H22.3333C21.597 34.3281 21 34.9251 21 35.6615V39.6615C21 40.3978 21.597 40.9948 22.3333 40.9948H29C29.7364 40.9948 30.3333 40.3978 30.3333 39.6615V35.6615C30.3333 34.9251 29.7364 34.3281 29 34.3281Z",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34.3281H22.3333C21.597 34.3281 21 34.9251 21 35.6615V39.6615C21 40.3978 21.597 40.9948 22.3333 40.9948H29C29.7364 40.9948 30.3333 40.3978 30.3333 39.6615V35.6615C30.3333 34.9251 29.7364 34.3281 29 34.3281Z",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleDashboard);
export default __webpack_public_path__ + "static/media/single_dashboard.f9e992c5e81868e0f31c4750e3da12b5.svg";
export { ForwardRef as ReactComponent };